import { useEffect } from 'react';
import { useTitle } from '../../context/TitleContext';
import { Row, Col } from 'react-bootstrap';
import AddCategory from './components/AddCategory';
import '../../styles/products.scss';

const CategoryCreate = () => {
  const { setTitle } = useTitle();

  useEffect(() => {
    setTitle('Créer une Catégorie');
  }, [setTitle]);

  return (
    <div className="category-create-page">
      <Row className="g-3">
        <Col xl={12} lg={12}>
          <AddCategory />
        </Col>
      </Row>
    </div>
  );
};

export default CategoryCreate;
